import {Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';

import {QueryParamsService} from '../../core/services/query-params.service';


@Injectable()
export class FileRestService {

  constructor(
    public http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  getFile(fileUrl: string): Observable<File> {
    return from(this.http.get(fileUrl, { responseType: 'blob' }).toPromise()
      .then((blob) => {
        if (!blob) {
          throw new Error('Empty file response');
        }
        return blob;
      })
      .then((blob) => {
        const imgParts = fileUrl.split('/').pop() || 'file';
        return new File([blob], imgParts, { type: blob.type, lastModified: Date.now() });
      })
      .catch((error) => {
        console.error("Error fetching file:", error);
        throw new Error("Failed to fetch file due to CORS issue or network error");
      }));
  }
}
